import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import DigitalTwinTab from './components/twin/DigitalTwinTab';
import ComparisonPage from './pages/ComparisonPage';

/**
 * DigitalTwinWrapper - Extracts projectId from route params and passes to DigitalTwinTab.
 */
function DigitalTwinWrapper() {
  const { projectId } = useParams();
  return <DigitalTwinTab projectId={projectId} />;
}

/**
 * Flux EMS App - Energy Management System
 *
 * All routes are project-scoped: /ems/:projectId/*
 * The shell app mounts this at /ems/*
 *
 * Main view is Digital Twin with mode selector (Annual / Real-Time).
 */
export default function FluxEMSApp() {
  return (
    <Routes>
      {/* Digital Twin — main view with mode selector */}
      <Route path="/:projectId" element={<DigitalTwinWrapper />} />
      <Route path="/:projectId/twin" element={<DigitalTwinWrapper />} />

      {/* Comparison: independent vs orchestrated */}
      <Route path="/:projectId/comparison" element={<ComparisonPage />} />

      {/* Catch all — redirect to unified projects */}
      <Route path="*" element={<Navigate to="/all-projects" replace />} />
    </Routes>
  );
}
